import { motion } from 'motion/react'
import { useState, useEffect } from 'react'

import { withPublicImageUrl } from '@lib/utils/cdn'

import {
  Stage,
  SEND_BUTTON_CLICK_DURATION,
  CHAT_INPUT_HEIGHT_ANIMATION_DURATION,
  THINKING_STAY_VISIBLE_DURATION,
  MESSAGE_VISIBLE_ANIMATION_DURATION,
  RESPONSE_VISIBLE_ANIMATION_DURATION,
} from './constants'
import { Thinking } from './thinking'

import style from './chat-thread.module.scss'

export const ChatThread = ({ stage }: { stage: Stage }) => {
  const [showResponse, setShowResponse] = useState<'thinking' | 'response' | null>(null)

  const thinkingHeight = '5rem'
  const messageVisibleDelay = SEND_BUTTON_CLICK_DURATION + CHAT_INPUT_HEIGHT_ANIMATION_DURATION

  useEffect(() => {
    if (stage !== Stage.SEND) {
      setShowResponse(null)
      return
    }

    let timeoutId = setTimeout(() => {
      setShowResponse('thinking')

      timeoutId = setTimeout(() => {
        setShowResponse('response')
      }, THINKING_STAY_VISIBLE_DURATION * 1000)
    }, messageVisibleDelay * 1000)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [stage, messageVisibleDelay])

  return (
    <div className={style.threadContainer}>
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{
          opacity: stage === Stage.SEND ? 1 : 0,
          height: stage === Stage.SEND || stage === Stage.RESET ? '11.1rem' : 0,
        }}
        transition={{
          duration: MESSAGE_VISIBLE_ANIMATION_DURATION,
          delay: stage === Stage.SEND ? messageVisibleDelay : 0,
        }}
        className={style.message}
        style={{
          backgroundImage: `url(${withPublicImageUrl('superhuman-go-intro-go-chat-thread-message.svg')})`,
        }}
      />
      {showResponse === 'thinking' && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: thinkingHeight, opacity: 1 }}
        >
          <Thinking />
        </motion.div>
      )}
      <motion.div
        initial={{ height: showResponse === 'response' ? 0 : thinkingHeight, opacity: 0 }}
        animate={{
          height: showResponse === 'response' || stage === Stage.RESET ? '30.8rem' : 0,
          opacity: stage === Stage.SEND ? 1 : 0,
        }}
        transition={{
          duration: stage === Stage.SEND ? RESPONSE_VISIBLE_ANIMATION_DURATION : 0.3,
          height: { ease: [0.4, 0, 0.6, 1] },
        }}
        className={style.response}
        style={{
          backgroundImage: `url(${withPublicImageUrl('superhuman-go-intro-go-chat-thread-response.svg')})`,
        }}
      />
    </div>
  )
}
